import { render, staticRenderFns } from "./appealReview.vue?vue&type=template&id=351547b4&scoped=true&"
import script from "./appealReview.vue?vue&type=script&lang=js&"
export * from "./appealReview.vue?vue&type=script&lang=js&"
import style0 from "./appealReview.vue?vue&type=style&index=0&id=351547b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351547b4",
  null
  
)

export default component.exports